
<div class="container">
    <mat-icon 
        aria-hidden="false" 
        aria-label="Example home icon" 
        style="color: {{color}}">{{icon}}</mat-icon>
    <span class="title" style="color: {{color}}">{{title}}</span>
</div>